<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>Fotoğraf Galerisi</b-card-title>
      <div>
        <b-button
          variant="primary"
          class="mr-1"
          @click="setModal('products-media',cropperSettings.fileName)"
        >
          <FeatherIcon icon="UploadIcon" />
          Fotoğraf Yükle
        </b-button>
        <b-button
          variant="success"
          class="mr-1"
          @click="triggerBatchUpload"
        >
          <FeatherIcon icon="UploadIcon" />
          Toplu Fotoğraf Yükle
        </b-button>
        <input
          ref="batchFileInput"
          type="file"
          multiple
          accept="image/*"
          style="display: none;"
          @change="handleBatchUpload"
        />
      </div>
    </b-card-header>
    <b-card-body>
      <div
        v-if="dataItem.images"
      >
        <draggable
          v-model="images"
          tag="ul"
          class="cursor-move p-0 row match-height"
        >
          <div
            v-for="(image, index) in images"
            :key="index"
            tag="li"
            class="col-auto col-md-3"
          >
            <div
              class="border-light rounded p-1 mb-2"
              :class="image.id? 'bg-light-primary' : 'bg-light-warning'"
            >
              <div
                class="height-auto overflow-hidden"
                :class="image.id? 'bg-light-primary' : 'bg-light-warning'"
              >
                <b-img
                  :src="imageUrl + '/media/products-media/' + image.thumb"
                  fluid
                  class="h-auto w-100"
                />
                <b-form-input
                  v-model="image.title"
                  size="sm"
                  class="mt-1"
                  placeholder="Görsel Açıklama"
                />
              </div>
              <div class="border-top mt-1 d-flex justify-content-around">
                <b-button
                  variant="outline-success"
                  size="sm"
                  pill
                  class="btn-icon mt-1"
                  :disabled="!image.id"
                  @click="saveImage(image)"
                >
                  <FeatherIcon icon="CheckIcon" />
                </b-button>
                <b-button
                  variant="outline-danger"
                  size="sm"
                  pill
                  class="btn-icon mt-1"
                  @click="removeImage(image,index)"
                >
                  <FeatherIcon icon="TrashIcon" />
                </b-button>
              </div>
            </div>
          </div>
        </draggable>
        <b-alert
          show
          variant="info"
        >
          <div class="alert-body text-center">
            <FeatherIcon icon="InfoIcon" /> Fotoğrafları sıralamak için sürükleyin.
          </div>
        </b-alert>
        <hr>
      </div>
      <div v-if="isUploadingBatch" class="mt-3">
        <b-alert show variant="info">
          <div class="alert-body">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span>Fotoğraflar yükleniyor...</span>
              <span>{{ Math.round(batchUploadProgress) }}%</span>
            </div>
            <b-progress :value="batchUploadProgress" :max="100" animated />
          </div>
        </b-alert>
      </div>
    </b-card-body>
    <cropper-image
        v-if="cropperSettings.type"
        :modal-status="cropperSettings.modalStatus"
        :close-modal="closeModal"
        :file-name="cropperSettings.fileName"
        :folder="cropperSettings.folder"
        :ratio="cropperSettings.ratio"
        :width-size="cropperSettings.widthSize"
        component="products-media"
        :params="cropperSettings.type"
        :item-id="dataItem.id"
        @uploadImage="setUploadImage"
    />
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BImg, BButton, BAlert, BFormInput, BProgress,
} from 'bootstrap-vue'
import draggable from 'vuedraggable'
import CropperImage from '@/layouts/components/common/CropperImage3.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'PhotoGallery',
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BImg,
    BButton,
    BFormInput,
    BAlert,
    BProgress,
    draggable,
    CropperImage,
  },
  data() {
    return {
      imageUrl: this.$store.state.app.baseURL,
      images: [],
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      },
      isUploadingBatch: false,
      batchUploadProgress: 0,
    }
  },
  computed: {
    dataItem() {
      const data = this.$store.getters['products/dataItem']
      if (data) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.images = data.images
      }
      return data
    },
  },
  watch: {
    images() {
      this.$store.dispatch('products/reOrderingImages', this.images)
    },
  },
  methods: {
    setModal(type,file) {
      const fileNamee = file?.name
      if (type === 'products-media') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: fileNamee,
          widthSize: 'auto',
          folder: 'products-media',
          ratio: 'auto' / 'auto',
          type: 'products-media',
        }
      }
    },
    closeModal() {
      this.cropperSettings = {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      }
    },
    setUploadImage(item) {
      if (this.cropperSettings.type === 'products-media') {
        this.dataItem.images.push({
          id: null,
          title: null,
          filename: item.filename,
          thumb: item.thumb,
          filename_webp: item.filename_webp,
          thumb_webp: item.thumb_webp,
        })
      }
      this.cropperSettings.modalStatus = false
    },
    saveImage(data) {
      this.$store.dispatch('products/saveImage', data)
    },
    removeImage(data, index) {
      if (data.id) {
        this.$store.dispatch('products/removeImageData', data)
          .then(response => {
            if (response) {
              this.dataItem.images.splice(index, 1)
            }
          })
      } else {
        this.dataItem.images.splice(index, 1)
      }
    },
    triggerBatchUpload() {
      this.$refs.batchFileInput.click()
    },
    async handleBatchUpload(event) {
      const files = Array.from(event.target.files)
      if (files.length === 0) return

      this.isUploadingBatch = true
      this.batchUploadProgress = 0

      try {
        for (let i = 0; i < files.length; i++) {
          const file = files[i]
          await this.uploadSingleFile(file)
          this.batchUploadProgress = ((i + 1) / files.length) * 100
        }

        this.showToast({
          title: 'Başarılı!',
          icon: 'CheckIcon',
          text: `${files.length} fotoğraf başarıyla yüklendi.`,
          variant: 'success',
        })
      } catch (error) {
        console.error('Toplu yükleme hatası:', error)
        this.showToast({
          title: 'Hata!',
          icon: 'XIcon',
          text: 'Fotoğraflar yüklenirken bir hata oluştu.',
          variant: 'danger',
        })
      } finally {
        this.isUploadingBatch = false
        this.batchUploadProgress = 0
        // Input'u temizle
        event.target.value = ''
      }
    },
    async uploadSingleFile(file) {
      try {
        // File zaten bir Blob türü, direkt kullanabiliriz
        const response = await this.$store.dispatch('cropperUploads/uploadImage2', {
          folder: 'products-media',
          resize: true,
          width: 'auto',
          thumb: true,
          webp: true,
          ordering: 0,
          component: 'products-media',
          params: 'products-media',
          item_id: this.dataItem.id,
          filename: file.name,
          upload_image: file,
        })

        if (response && response.status) {
          // Başarılı yükleme sonrası görseli listeye ekle
          this.dataItem.images.push({
            id: null,
            title: null,
            filename: response.data.filename,
            thumb: response.data.thumb,
            filename_webp: response.data.filename_webp,
            thumb_webp: response.data.thumb_webp,
          })
          return response
        } else {
          throw new Error('Yükleme başarısız')
        }
      } catch (error) {
        console.error('Dosya yükleme hatası:', error)
        throw error
      }
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: params,
      })
    },
  },
}
</script>
